var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_7087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.976745 20C0.783573 20 0.594729 19.9428 0.434101 19.8355C0.273472 19.7282 0.148276 19.5756 0.074347 19.3972C0.000418327 19.2187 -0.0189212 19.0223 0.0187748 18.8329C0.0564707 18.6434 0.149509 18.4694 0.28612 18.3328L18.333 0.285944C18.5162 0.102779 18.7646 -0.00012207 19.0236 -0.00012207C19.2827 -0.00012207 19.5311 0.102779 19.7142 0.285944C19.8974 0.469109 20.0003 0.717535 20.0003 0.976569C20.0003 1.2356 19.8974 1.48403 19.7142 1.66719L1.66737 19.7141C1.57676 19.8049 1.4691 19.8769 1.35058 19.9259C1.23207 19.975 1.10502 20.0002 0.976745 20Z",
    fill: "#8F9EA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0236 20C18.8953 20.0002 18.7682 19.975 18.6497 19.9259C18.5312 19.8769 18.4236 19.8049 18.3329 19.7141L0.286066 1.66719C0.102901 1.48403 0 1.2356 0 0.976569C0 0.717535 0.102901 0.469109 0.286066 0.285944C0.469231 0.102779 0.717657 -0.00012207 0.976691 -0.00012207C1.23573 -0.00012207 1.48415 0.102779 1.66732 0.285944L19.7142 18.3328C19.8508 18.4694 19.9438 18.6434 19.9815 18.8329C20.0192 19.0223 19.9999 19.2187 19.926 19.3972C19.852 19.5756 19.7268 19.7282 19.5662 19.8355C19.4056 19.9428 19.2167 20 19.0236 20Z",
    fill: "#8F9EA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_7087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.c4cd44ca5f2750c891e7a4a1cdf8ce03.svg";
export { ForwardRef as ReactComponent };